module.exports = __webpack_public_path__ + "img/blue_088.2a627b3d.png";